import { useEffect, useState } from 'react';

export interface UsePaginationProps {
  page: number;
  pageSize: number;
  onChangePage?: (page: number) => void;
  total: number;
  limit: number;
}

export const usePagination = (props: UsePaginationProps) => {
  const { page, total, limit, pageSize, onChangePage } = props;
  const [nowPage, setNowPage] = useState(page);
  const [pages, setPages] = useState<number[]>([1]);
  const lastPage = total > 0 ? Math.ceil(total / pageSize) : 0;
  const start =
    nowPage % limit === 0
      ? (Math.floor(nowPage / limit) - 1) * limit + 1
      : Math.floor(nowPage / limit) * limit + 1;

  const buttonCount = lastPage - start < limit ? lastPage - start + 1 : limit;

  const calculatePage = () => {
    if (buttonCount > 0)
      return Array.from(Array(buttonCount), (_, index) => {
        return {
          value: start + index,
        };
      }).map(item => {
        return item.value;
      });
    return [];
  };

  const handleClickPrev = () => {
    let returnValue = nowPage - 1;
    if (1 === nowPage) returnValue = nowPage;
    setNowPage(returnValue);
    if (onChangePage) onChangePage(returnValue);
  };
  const handleClickNext = () => {
    let returnValue = nowPage + 1;
    if (Math.ceil(total / pageSize) === nowPage) returnValue = nowPage;
    setNowPage(returnValue);
    if (onChangePage) onChangePage(returnValue);
  };
  const handleClickFirst = () => {
    setNowPage(1);
    if (onChangePage) onChangePage(1);
  };
  const handleClickLast = () => {
    setNowPage(lastPage);
    if (onChangePage) onChangePage(lastPage);
  };
  const handleClickPageButton = (page: number) => {
    setNowPage(page);
    if (onChangePage) onChangePage(page);
  };
  useEffect(() => {
    setNowPage(page);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);
  useEffect(() => {
    setPages(calculatePage());

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nowPage, start, lastPage]);

  return {
    // 계산된 페이지? 현재 페이지를 가지고 어떤 페이지를 보여줘야 할지
    pages,
    // pageSize, page 계산된
    calculatePage,
    // ->
    handleClickNext,
    // <-
    handleClickPrev,
    // 1
    handleClickFirst,
    // last
    handleClickLast,
    // page click
    handleClickPageButton,

    // 현재 페이지
    nowPage,
    // start
    start,
    //
    buttonCount,
    lastPage,
  };
};
